'use strict';

exports.__esModule = true;
var UrlUpdateTypes = {
  replace: 'replace',
  replaceIn: 'replaceIn',
  push: 'push',
  pushIn: 'pushIn'
};

exports.default = UrlUpdateTypes;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-url-query/lib/UrlUpdateTypes.js
// module id = 7
// module chunks = 0